export { WinnerTicket } from './WinnerTicket';
